export const app_types = {
    "Internal": 0,
    "Brand": 1,
    "Broker": 2,
}